import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight, Phone, Calendar } from 'lucide-react';

export const CTA = () => {
  return (
    <section className="py-20 md:py-32 bg-[#0f172a]" data-testid="cta-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-8">
            <div>
              <p className="text-sm tracking-wide uppercase font-semibold text-[#2563eb] mb-4">
                Ready to Grow?
              </p>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight mb-6">
                Stop Chasing Leads.<br />
                Start Closing Deals.
              </h2>
              <p className="text-lg text-white/70 leading-relaxed">
                Join hundreds of home service contractors who've transformed their businesses 
                with RenoNovo's exclusive appointment generation. Book a free strategy call 
                today and see how we can help you grow.
              </p>
            </div>

            {/* Benefits List */}
            <ul className="space-y-4">
              {[
                'Free strategy consultation',
                'Custom growth plan for your business',
                'No obligation — just valuable insights',
              ].map((item, index) => (
                <li key={index} className="flex items-center gap-3 text-white/90">
                  <div className="w-6 h-6 bg-[#2563eb] rounded-full flex items-center justify-center flex-shrink-0">
                    <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span>{item}</span>
                </li>
              ))}
            </ul>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/book-call">
                <Button 
                  className="bg-[#2563eb] hover:bg-[#1d4ed8] text-white font-semibold px-8 h-14 rounded-sm text-base shadow-[0_4px_14px_0_rgba(37,99,235,0.39)] hover:shadow-[0_6px_20px_0_rgba(37,99,235,0.5)] transition-all duration-200 hover:-translate-y-0.5 group w-full sm:w-auto"
                  data-testid="cta-primary-btn"
                >
                  <Calendar className="mr-2 w-5 h-5" />
                  Book Free Strategy Call
                  <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform duration-200" />
                </Button>
              </Link>
              <a href="tel:+13212102777">
                <Button 
                  variant="outline"
                  className="bg-transparent text-white font-semibold px-8 h-14 rounded-sm text-base border-2 border-white/30 hover:border-white/60 hover:bg-white/10 transition-all duration-200 w-full sm:w-auto"
                  data-testid="cta-phone-btn"
                >
                  <Phone className="mr-2 w-5 h-5" />
                  (321) 210-2777
                </Button>
              </a>
            </div>
          </div>

          {/* Visual Element */}
          <div className="relative">
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-sm p-8">
              <div className="space-y-6">
                <div className="flex items-center gap-4 p-4 bg-white/10 rounded-sm">
                  <div className="w-12 h-12 bg-[#2563eb] rounded-full flex items-center justify-center">
                    <Calendar className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <p className="text-white font-semibold">New Appointment Booked</p>
                    <p className="text-white/60 text-sm">Kitchen Remodel - $45,000 estimate</p>
                  </div>
                </div>
                <div className="flex items-center gap-4 p-4 bg-white/10 rounded-sm">
                  <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                    <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-white font-semibold">Contract Signed!</p>
                    <p className="text-white/60 text-sm">Pool Installation - $85,000</p>
                  </div>
                </div>
                <div className="flex items-center gap-4 p-4 bg-white/10 rounded-sm">
                  <div className="w-12 h-12 bg-[#2563eb] rounded-full flex items-center justify-center">
                    <Phone className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <p className="text-white font-semibold">Qualified Call Incoming</p>
                    <p className="text-white/60 text-sm">HVAC Service - Ready to book</p>
                  </div>
                </div>
              </div>
              
              {/* Stats Badge */}
              <div className="mt-8 pt-6 border-t border-white/20">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-white/60 text-sm">This Month's Revenue</p>
                    <p className="text-3xl font-bold text-[#2563eb]">$247,500</p>
                  </div>
                  <div className="text-right">
                    <p className="text-white/60 text-sm">Appointments</p>
                    <p className="text-3xl font-bold text-white">24</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
